import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import Fade from 'react-reveal/Fade'

function KeyMaterial () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("CompositeReinforcement.6")}</Trans>
                    </p>
                </div>
                <div className='flex flex-wrap justify-between gap-y-[50px] mt-[40px] xl:mt-[65px]'>
                    <Fade bottom><div className='sm:mx-auto flex flex-row md:flex-col items-center md:items-start gap-[10px] md:gap-0'>
                        <div className='hidden xl:flex flex-col md:flex-row gap-[16px] md:gap-[24px] items-center'>
                            <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                            <div className='w-px h-[60px] md:h-px md:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                        </div>
                        <div className='max-w-[334px]'>
                            <p className='open-sans text-[16px] xl:text-[20px] text-[#F26522] md:mt-[45px]'>{t('CompositeReinforcement.7')}</p>
                        </div>
                    </div>
                    </Fade> 
                    <Fade bottom><div className='sm:mx-auto flex flex-row md:flex-col items-center md:items-start gap-[10px] md:gap-0'>
                        <div className='hidden xl:flex flex-col md:flex-row gap-[16px] md:gap-[24px] items-center'>
                            <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                            <div className='w-px h-[60px] md:h-px md:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                        </div>
                        <div className='max-w-[334px]'>
                            <p className='open-sans text-[16px] xl:text-[20px] text-[#F26522] md:mt-[45px]'>{t('CompositeReinforcement.10')}</p>
                        </div>
                    </div>
                    </Fade>
                    <Fade bottom><div className='sm:mx-auto flex flex-row md:flex-col items-center md:items-start gap-[10px] md:gap-0'>
                        <div className='hidden xl:flex flex-col md:flex-row gap-[16px] md:gap-[24px] items-center'>
                            <div className='w-[16px] md:w-[24px] h-[16px] md:h-[24px] rounded-full bg-[#F26522]'></div>
                            <div className='w-px h-[60px] md:h-px md:w-[334px] border border-dashed border-[#F26522] opacity-[0.4]'></div>
                        </div>
                        <div className='max-w-[334px]'>
                            <p className='open-sans text-[16px] xl:text-[20px] text-[#F26522] md:mt-[45px]'>{t('CompositeReinforcement.13')}</p>
                        </div>
                    </div>
                    </Fade>                  
                </div>
            </div>
        </div>
    );
}

export default KeyMaterial;